var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workspace-layout theme-v3"},[_c('WorkspaceSidebar'),_c('section',{staticClass:"workspace-content"},[_c('WorkspaceTopBar'),_c('main',{staticClass:"workspace-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }